/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText } from 'sarsaparilla';
import './MobileCoverageSectionPlaceholder.scss';

export default function MobileCoverageSectionPlaceholder() {
    return (
        <div
            className="campground-page-v3-mobile-coverage campground-page-v3-section"
            id="campground-page-v3-mobile-coverage-section"
            aria-hidden="true"
        >
            <Placeholder
                className="campground-page-v3-mobile-coverage-placeholder-heading"
                height="32px"
                width="220px"
            />
            <div className="campground-page-v3-mobile-coverage-cards-container campground-page-v3-mobile-coverage-placeholder-cards">
                {Array.from({ length: 3 }).map((_, index) => (
                    <div
                        key={`mobile-coverage-placeholder-${index}`}
                        className="campground-page-v3-mobile-coverage-card campground-page-v3-mobile-coverage-placeholder-card"
                    >
                        <PlaceholderText fontSize={21} lineHeight={24} lines={3} />
                    </div>
                ))}
            </div>
        </div>
    );
}
